document.addEventListener("DOMContentLoaded", function() {
  window.addEventListener("scroll", function() {
    var currentScrollPos = window.pageYOffset;
    if (0 < currentScrollPos) {
      document.querySelector(".logo").classList.add("hide-logo");
      document.querySelector(".logosub").classList.add("hide-logosub");
    } 
    else{
      document.querySelector(".logo").classList.remove("hide-logo");
      document.querySelector(".logosub").classList.remove("hide-logosub");
    }
  });
});

